import { generatePath } from "react-router"
import type { RouteChildren, RouteTree, RouteNode, RouteParams, RouteDefinition } from "./types"
import { joinPatterns, formatPathParams } from "./utils"

export const route = <const Segment extends string, const Children extends RouteChildren | undefined = undefined>(
  segment: Segment,
  children?: Children
): RouteDefinition<Segment, Children> => {
  return { segment, children }
}

export const defineRouteTree = <const Tree extends RouteChildren>(tree: Tree): RouteTree<Tree> => {
  return buildRouteTree(tree, "") as RouteTree<Tree>
}

function buildRouteTree(tree: RouteChildren, parentPattern: string): Record<string, RouteNode> {
  return Object.fromEntries(
    Object.entries(tree).map(([key, routeDefinition]) => {
      const pattern = joinPatterns(parentPattern, routeDefinition.segment)

      return [
        key,
        {
          id: pattern,
          segment: routeDefinition.segment,
          pattern: pattern,
          path: (params?: RouteParams) => {
            return generatePath(pattern, formatPathParams(params))
          },
          ...(routeDefinition.children ? buildRouteTree(routeDefinition.children as RouteChildren, pattern) : {}),
        },
      ]
    })
  )
}
